<template>
  <img :src="linkComputed" alt="">
</template>

<script>
/* Display image component (only) */
export default {
  name: 'ImageComponent',
  props: {
    iri: { type: String, required: true },
  },
  data() {
    return {
      link: '',
    };
  },
  computed: {
    linkComputed() {
      return this.link;
    },
  },
  methods: {
    async getLink() {
      this.$http.get(this.iri).then((res) => {
        this.link = this.$http.defaults.baseURL + res.data.contentUrl;
      });
    },
  },
  watch: {
    iri() {
      this.getLink();
    },
  },
  created() {
    this.getLink();
  },
};
</script>

<style scoped>

</style>
